export default __webpack_public_path__ + "static/media/pilz-01.31d989c1.png";